export enum OddsFormat {
    American = "American"
}